angular
  .module 'shared'
  .factory 'EzidebitService', () ->
    getCustomerReference: (params) ->
      rnd = Math.floor(Math.random() * 10000000000)
      "#{params.gymId}-#{params.context}-#{params.contactId || 'NEW'}-#{moment().unix()}-#{rnd}"
